import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=1745a430&scoped=true&"
import script from "./Database.vue?vue&type=script&lang=js&"
export * from "./Database.vue?vue&type=script&lang=js&"
import style0 from "./Database.vue?vue&type=style&index=0&id=1745a430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745a430",
  null
  
)

export default component.exports